/** @jsx jsx */
import { jsx, css } from '@emotion/core';

import { Grid, Typography, useMediaQuery, useTheme } from '@material-ui/core';
import { RouteComponentProps } from '@reach/router';
import React from 'react';
import usePaymentForm from '../../hooks/usePaymentForm';
import routes from '../../routes';
import { OneTimePayConfigData } from '../payment-form/oneTimePayment.types';
import PaymentVerificationForm from '../payment-form/payment-verification-form';
import { toCurrencyString } from '../../util/format';
import { navigate } from 'gatsby';
import useContentMgmt from '../../hooks/useContentMgmt';
import microcopyGroupIds from '../pge-plus-common/microcopyGroupIds';
import { Application } from '../../__generated__/pgeplus-types';
import { getInvoiceUrl } from './utils/navigation.util';
import useInvoicePaymentAuthQuery from '../../hooks/invoice-payment-portal/useInvoicePaymentAuthQuery';
import { GET_PAYMENT_PROFILE_FEE } from '../../hooks/invoice-payment-portal/useInvoicePayment';
import { PaymentFee, PaymentFeeResponse } from '../../__generated__/pge-types';
import Backdrop from '../backdrop/Backdrop';

type Props = RouteComponentProps & {
  paymentInfo: OneTimePayConfigData;
  onSubmit: () => void;
  invoiceId: string;
  paymentMethodCapLimit: number;
};

const PaymentVerify: React.FC<Props> = ({
  paymentInfo,
  onSubmit,
  invoiceId,
  paymentMethodCapLimit,
}) => {
   
  
  const payBillProps = usePaymentForm();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const childProps = { isMobile, ...payBillProps };

  const { content } = useContentMgmt(
    microcopyGroupIds.INVOICE_PAYMENT_FORM,
  );
  
  const {
      loading: feeLoading,
      data: feeData,
    } = useInvoicePaymentAuthQuery<{
      getPaymentFee: PaymentFeeResponse;
    }>(GET_PAYMENT_PROFILE_FEE, {
      variables: {
        payload: 
        {
          paymentList: paymentInfo.paymentSelector?.selectedPaymentProfileList?.map((profile)=>
          {
          return {
            token: profile?.profile?.token,
            type: profile?.profile?.type?.toString(),
            invoiceId,
            paymentAmount: paymentMethodCapLimit === paymentInfo.paymentSelector?.selectedPaymentProfileList.length ? Number(profile?.value): Number(paymentInfo?.paymentAmount)
          }})
        }
      },
      context: {
        invoicePayment: true,
      },
  });

  const getFormattedPaymentAmount = () => {
    return paymentInfo?.paymentAmount
      ? `$${toCurrencyString(parseFloat(paymentInfo?.paymentAmount), false)}`
      : '';
  };
  if (feeLoading) {
      return <Backdrop forceOpen />;
    }
  return (
    <Grid container justify={'center'} alignItems={'center'} direction="column">
       <Grid item xs={12}>
        <Typography variant="h1">{content.get('INVOICE_PAYMENT_VERIFY_TITLE')}</Typography>
        </Grid>
      
      <Grid item css={{ width: '100%', marginBottom: theme.spacing(5) }}>
        <PaymentVerificationForm
          path={routes.INVOICE_PAYMENT_PORTAL_INVOICE_PAYMENT_VERIFY}
          {...childProps}
          oneTimePayConfigData={paymentInfo}
          formattedPaymentAmount={getFormattedPaymentAmount()}
          onSubmit={onSubmit}
          paymentMethodCapLimit={paymentMethodCapLimit}
          backButtonRoute={getInvoiceUrl(
            routes.INVOICE_PAYMENT_PORTAL_INVOICE_PAYMENT_INFO,
            invoiceId,
          )}
          nextButtonText={content.get('PAY_BILL') || ''}
          paymentFee={feeData?.getPaymentFee?.profileFeeList as PaymentFee[] || []}    
          cancelButtonRoute={routes.INVOICE_PAYMENT_PORTAL_INVOICE_LIST}
          isInvoicePayment={true}
        />
      </Grid>
    </Grid>
  );
};

export default PaymentVerify;
